import styled from "styled-components";
import PageTitle from "../../components/ui/PageTitle";
import { Headphones } from "@phosphor-icons/react";
import ReciterCard from "./ReciterCard";

type Reciter = { id: string; name: string; image: string };

const reciters: Reciter[] = [
  { id: "ar.minshawi", name: "محمد المنشاوي", image: "/images/reciters/minshawi.jpg" },
  { id: "ar.kazemi",   name: "عامر الكاظمي",   image: "/images/reciters/kademi.jpg"   },
  { id: "ar.kjalil",   name: "خالد الجليل",    image: "/images/reciters/kjalil.jpg"   },
  { id: "ar.mrashad",  name: "محمد رشاد",      image: "/images/reciters/mrashad.jpg"  },
  { id: "ar.maher",    name: "ماهر المعيقلي",  image: "/images/reciters/maher.jpg"    },
  { id: "ar.sghamdi",  name: "سعد الغامدي",    image: "/images/reciters/sghamdi.jpg"  },
  { id: "ar.ajmy",     name: "أحمد العجمي",    image: "/images/reciters/ajmy.jpg"     },
  { id: "ar.lahidan",  name: "محمد اللحيدان",  image: "/images/reciters/lahidan.jpg"  },
  { id: "ar.mrayan",   name: "محمد ريان",      image: "/images/reciters/mrayan.jpg"   },
];

export default function ListenIndexPage() {
  return (
    <GradientBg>
      <Container>
        <HeaderSpace />
        <PageTitle
          icon={<Headphones size={24} weight="duotone" style={{ marginInlineEnd: 8 }} color="var(--primary)" />}
          center gap={8} as="h1"
        >
          الاستماع للقرآن
        </PageTitle>
        <Subtitle>استمع لتلاوة القارئ الذي تختاره</Subtitle>

        <Grid>
          {reciters.map((r) => (
            <ReciterCard
              key={r.id}
              name={r.name}
              image={r.image}
              href={`/listen/${encodeURIComponent(r.id)}`}
            />
          ))}
        </Grid>
      </Container>
    </GradientBg>
  );
}

const GradientBg = styled.div` min-height:100dvh; display:flex; flex-direction:column; `;
const Container = styled.div` padding-bottom:32px; flex:1; `;
const HeaderSpace = styled.div` height:20px; `;
const Subtitle = styled.p` text-align:center; margin:6px 0 18px; color:var(--muted); font-size:.95rem; `;
const Grid = styled.div`
  display:grid; gap:16px; grid-template-columns:repeat(3, minmax(0, 150px)); justify-content:center;
`;
